// @flow
import * as React from 'react';
import RadioButton from 'components/RadioButton';
import Field from './Field';

const RadioButtonsField = ({
  name,
  label,
  value,
  ...props
}: {
  name: string,
  label: string,
  value: string
}) => (
  <Field
    inputProps={props}
    name={name}
    renderInput={({
      value: selectedValue,
      id,
      qaId,
      hasError,
      updateValue
    }) => (
      <RadioButton
        id={`${id}-${value}`}
        name={name}
        value={value}
        label={label}
        checked={value === selectedValue}
        hasError={hasError}
        onChange={updateValue}
        data-qa-id={`${qaId}-${value}`}
        {...props}
      />
    )}
  />
);

export default RadioButtonsField;
